import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, CircularProgress, Typography, Stack, Button } from '@mui/material';
import apiService from '../services/api.service';
import { showSnackbar } from '../store/slices/uiSlice';

const ApprovalLink: React.FC = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const run = async () => {
      if (!token) {
        dispatch(showSnackbar({ message: 'Invalid approval link', severity: 'error' }));
        return;
      }
      try {
        const res = await apiService.resolveApprovalToken(token);
        const d = (res as any)?.data || res || {};
        if (d && d.success !== false) {
          const id = Number((d.data?.prid ?? d.prid) || 0);
          if (id > 0) {
            dispatch(showSnackbar({ message: 'Approval link opened', severity: 'success' }));
            navigate(`/pr/${id}`);
            return;
          }
        }
        dispatch(showSnackbar({ message: 'Invalid approval link', severity: 'error' }));
      } catch (e: any) {
        const status = Number((e?.response?.status) || 0);
        if (status === 410) {
          dispatch(showSnackbar({ message: 'Approval link expired', severity: 'warning' }));
        } else if (status === 401) {
          dispatch(showSnackbar({ message: 'Please login to continue', severity: 'info' }));
          navigate('/login');
        } else {
          dispatch(showSnackbar({ message: 'Unable to open approval link', severity: 'error' }));
        }
      }
    };
    run();
  }, [token, navigate, dispatch]);

  return (
    <Box component="main" id="main-content" sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '50vh' }}
        role="status"
        aria-live="polite"
      >
        <CircularProgress aria-label="Opening approval link" />
        <Typography variant="body2">Opening approval link…</Typography>
        <Button variant="outlined" onClick={() => navigate('/inbox')}>Go to Inbox</Button>
      </Stack>
    </Box>
  );
};

export default ApprovalLink;